import Modal from 'services/modal';
import BaseService from 'services/base';

const BillingService = Object.assign(
  {
    save(config: any = {}, cb: Function = () => {}, dispatch: Function) {},

    //替换为账款方法
    publishOrder(postbody: any, cb: Function = () => {}, dispatch: Function) {
      let ok = () => {
        let config = {
          ...postbody,
          apiPath: '/purchase/publishOrder',
          successMsg: '发布成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('您确定发布采购订单吗？', ok, dispatch);
    },

    //确认对账单
    confirmVendorStatement(
      postbody: any,
      cb: Function = () => {},
      dispatch: Function
    ) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('是否确认对账单？', ok, dispatch);
    },

    //退回对账单
    rejectVendorStatement(
      postbody: any,
      cb: Function = () => {},
      dispatch: Function
    ) {
      let ok = (reason?) => {
        if (!reason) {
          Modal.showError('退回原因不能为空', dispatch);
          return;
        }
        let config = {
          ...postbody,
          returnDesc: reason,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showReject(
        '确认退回对账单？',
        ok,
        '退回',
        'showReject',
        '',
        dispatch
      );
    },

    //对账单确认发出
    publishVStatement(
      postbody: any,
      cb: Function = () => {},
      dispatch: Function
    ) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('确认发布对账单？', ok, dispatch);
    },

    //对账单数量审核
    confirmQty(postbody: any, cb: Function = () => {}, dispatch: Function) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('是否确认数量？', ok, dispatch);
    },

    //撤回对账单
    recallVStatement(
      postbody: any,
      cb: Function = () => {},
      dispatch: Function
    ) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('确认撤回对账单？', ok, dispatch);
    },

    //作废对账单
    cancelVStatement(
      postbody: any,
      cb: Function = () => {},
      dispatch: Function
    ) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('确认作废对账单？', ok, dispatch);
    },

    //对账单-删除
    deleteVStatement(
      postbody: any,
      cb: Function = () => {},
      dispatch: Function
    ) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('确认删除对账单？', ok, dispatch);
    },

    //采购方费用单操作（本方发起） [发布|撤回|作废]
    handleCostOrder(
      postbody,
      action: string,
      cb: Function = () => {},
      dispatch: Function
    ) {
      const PRESET = {
        publish: {
          apiPath: '/costsheetOrder/publish',
          modalMsg: '是否发布费用单？',
          successMsg: '发布成功'
        },
        withdraw: {
          apiPath: '/costsheetOrder/revoke',
          modalMsg: '是否撤回费用单？',
          successMsg: '撤回成功'
        },
        void: {
          apiPath: '/costsheetOrder/abandon',
          modalMsg: '是否作废费用单？',
          successMsg: '作废成功'
        }
      };
      let ok = () => {
        let config = {
          ...postbody,
          apiPath: PRESET[action].apiPath,
          successMsg: PRESET[action].successMsg
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm(PRESET[action].modalMsg, ok, dispatch);
    },
    //供应商费用单操作（本方发起） [发布|撤回|作废]
    handleCustExpenseSheet(
      postbody,
      action: string,
      cb: Function = () => {},
      dispatch: Function
    ) {
      const PRESET = {
        publish: {
          apiPath: '/cCostsheetOrder/send',
          modalMsg: '是否发布费用单？',
          successMsg: '发布成功'
        },
        withdraw: {
          apiPath: '/cCostsheetOrder/revoke',
          modalMsg: '是否撤回费用单？',
          successMsg: '撤回成功'
        },
        void: {
          apiPath: '/cCostsheetOrder/abandon',
          modalMsg: '是否作废费用单？',
          successMsg: '作废成功'
        }
      };
      let ok = () => {
        let config = {
          ...postbody,
          apiPath: PRESET[action].apiPath,
          successMsg: PRESET[action].successMsg
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm(PRESET[action].modalMsg, ok, dispatch);
    },
    //费用单-删除
    deleteCostsheet(
      postbody: any,
      cb: Function = () => {},
      dispatch: Function
    ) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('确认删除费用单？', ok, dispatch);
    },
    //采购方费用单 确认、退回
    replyCostOrder(
      postbody,
      action: string,
      cb: Function = () => {},
      dispatch: Function
    ) {
      const PRESET = {
        confirm: {
          apiPath: '/costsheetOrder/confirm',
          successMsg: '确认成功'
        },
        return: {
          apiPath: '/costsheetOrder/sendBack',
          successMsg: '退回成功'
        }
      };

      let config = {
        ...postbody,
        returnDesc: null,
        apiPath: PRESET[action].apiPath,
        successMsg: PRESET[action].successMsg
      };

      if (action === 'confirm') {
        let ok = () => {
          this.save(config, cb, dispatch);
        };
        Modal.showConfirm('是否确认供应商费用单？', ok, dispatch);
      } else {
        let ok = (reason?) => {
          config.returnDesc = reason;
          if (!reason) {
            Modal.showError('退回原因不能为空', dispatch);
            return;
          }
          this.save(config, cb, dispatch);
        };
        Modal.showReject(
          '确认退回费用单？',
          ok,
          '退回',
          'showReject',
          '',
          dispatch
        );
      }
    },

    //删除发票通知
    deleteInvoice(postbody, cb: Function = () => {}, dispatch: Function) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('确认删除发票通知？', ok, dispatch);
    },

    //确认发出发票通知
    publishInvoice(postbody, cb: Function = () => {}, dispatch: Function) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('确认发出发票通知？', ok, dispatch);
    },

    //确认发票通知
    confirmInvoice(postbody, cb: Function = () => {}, dispatch: Function) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('确认发票通知？', ok, dispatch);
    },

    //作废发票通知
    invalidInvoice(postbody, cb: Function = () => {}, dispatch: Function) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('确认作废发票通知？', ok, dispatch);
    },

    //撤回供应商发票通知
    recallPurchaseInvoice(
      postbody,
      cb: Function = () => {},
      dispatch: Function
    ) {
      let ok = (reason?) => {
        if (!reason) {
          Modal.showError('撤回原因不能为空', dispatch);
          return;
        }
        let config = {
          ...postbody,
          returnDesc: reason,
          successMsg: '撤回成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showReject('撤回', ok, '撤回原因', 'showReject', '', dispatch);
    }
  },
  BaseService
);

export default BillingService;
